import React from 'react'
import { Link } from 'react-router-dom'
import type { OutputTypeHint } from './outputTypes'
import { WorkflowOutputField } from './WorkflowOutputField'
import { RunFileProvider } from './runFileContext'
import { useGetExternalUserByIdQuery } from '../../store/externalUser/externalUser'
import { getUserDisplayName } from '../../apps/professional-app/fa/common/aifeatures/utils'
import { isPerClientArray, type PerClientEntry } from './CcqWorkflowOutputs.helpers'

const ClientOutputSection: React.FC<{ accountId?: string; entry: PerClientEntry; hints?: Record<string, OutputTypeHint> }> = ({ accountId, entry, hints }) => {
  const clientId = entry.client_id
  const { data } = useGetExternalUserByIdQuery({ accountId: accountId ?? '', userId: clientId }, { skip: !accountId || !clientId })
  const name = getUserDisplayName(data?.data) || clientId
  const fields = Object.entries(entry).filter(([key]) => key !== 'client_id')

  return (
    <div className='zocks-bg-color-gray-100 rounded-2 p-3'>
      <div className='fw-semibold mb-2'>
        <Link className='zocks-text-primary' target='_blank' rel='noreferrer' to={`/library/manage-contacts/contacts/${clientId}`}>
          {name}
        </Link>
      </div>
      {fields.map(([key, value]) => (
        <WorkflowOutputField key={key} name={key} value={value} hint={hints?.[key]} />
      ))}
    </div>
  )
}

interface CcqWorkflowOutputsProps {
  outputs: Record<string, unknown>
  accountId?: string
  hints?: Record<string, OutputTypeHint>
  runFile?: { accountId: string; workflowId: string; runId: string }
}

export const CcqWorkflowOutputs: React.FC<CcqWorkflowOutputsProps> = ({ outputs, accountId, hints, runFile }) => {
  const content = Object.entries(outputs).map(([key, value]) =>
    isPerClientArray(value) ? (
      <div key={key} className='d-flex flex-column zocks-gap-3'>
        {value.map((entry, index) => (
          <ClientOutputSection key={entry.client_id || index} accountId={accountId} entry={entry} hints={hints} />
        ))}
      </div>
    ) : (
      <WorkflowOutputField key={key} name={key} value={value} hint={hints?.[key]} />
    ),
  )
  return runFile ? <RunFileProvider value={runFile}>{content}</RunFileProvider> : <>{content}</>
}
